import login from './login'
import nav from './_nav.json'
import activity from './activity'
import dict from './dict.json'
import demo from './demo.json'

export default {
  site_title: 'JDYun.com',
  title: 'JDYun 활동 시스템', // 웹사이트 제목
  system_demo: '시스템 데모',
  confirm: '확인',
  // 취소
  cancel: '취소',
  // 표시
  show: '표시',
  // 숨기기
  hide: '숨기기',
  // 열기
  open: '열기',
  // 닫기
  close: '닫기',
  // 저장
  save: '저장',
  // 편집
  edit: '편집',
  // 삭제
  delete: '삭제',
  // 추가
  add: '추가',
  // 검색
  search: '검색',
  // 조회
  query: '조회',
  // 초기화
  reset: '초기화',
  // 제출
  submit: '제출',
  // 업로드
  upload: '업로드',
  // 다운로드
  download: '다운로드',
  // 내보내기
  export: '내보내기',
  // 가져오기
  import: '가져오기',

  started: '시작됨',
  ended: '종료됨',
  // 다음
  next: '다음',
  // 이전
  prev: '이전',
  // 발표
  publish: '발표',
  // 입력해 주세요
  input: '{text}을(를) 입력해 주세요',
  // 선택해 주세요
  select: '{text}을(를) 선택해 주세요',
  total: '총 {total}개',
  price: '{price} 위안',
  required: '{text}은(는) 필수입니다',
  selected: '{total}개의 {text} 선택됨',
  // 새로 만들기
  create: '생성',
  // 무료
  free: '무료',
  // 유료
  charge: '유료',
  // 기본
  default: '기본',
  // 사용자 정의
  custom: '사용자 정의',
  // 최대
  max: '최대',
  // 최소
  min: '최소',
  // 백분율
  percent: '백분율',
  // 온라인
  online: '온라인',
  // 오프라인
  offline: '오프라인',
  name: '이름',
  // 비고
  remark: '비고',
  // 안내
  tips: '안내',
  // 상단 네비게이션
  header: {
    logout: '로그아웃',
    binding: '계정 연동',
    mobile: '모바일 가맹점 클라이언트',
    register: '모바일 클라이언트',
    tips: '활동 {name}',
    qrcodeText: '{name} H5 QR 코드',
    qrcodeMiniText: '{name} 미니프로그램 코드',
    qrcode: 'QR 코드 다운로드',
    qrcodeMini: '미니프로그램 코드 다운로드'
  },
  home: {
    title: 'JDYun 활동 관리 플랫폼에 오신 것을 환영합니다',
    sub_title: '여기서 가장 완벽하고 상세한 활동과 컨퍼런스를 발표하세요',
    desc: '활동 관리에서 활동 주최 여정을 시작하세요',
    create: '빠른 활동 생성'
  },
  user: {
    title: '계정 기본 정보',
    logo: '브랜드 로고',
    update: '업데이트',
    name: '회사 또는 조직 이름',
    short_name: '좌측 상단 메뉴 바의 브랜드',
    enable: '개인화 로그인 활성화',
    web_tips: '개인화 로그인 URL',
    copy: 'URL 복사',
    login: '로그인 페이지 브랜드 이름',
    login_title: '로그인 페이지 시스템 이름'
  },
  login,
  activity,
  demo,
  ...nav,
  ...dict,
  // 상태 코드 현지화
  // 작업 요청 성공
  2000: '작업 요청 성공',
  // 네트워크 오류
  5000: '네트워크 요청 오류, 네트워크를 확인해 주세요',
  // 요청 매개변수 오류
  5001: '요청 매개변수 오류',
  // URL 등록 실패
  5002: 'URL 등록 실패',
  // 매개변수 오류
  5003: '매개변수 오류',
  // 권한 오류
  5004: '권한 오류',
  // JWT 검증 오류
  5100: 'JWT 검증 실패',
  // 로그인 실패
  5101: '로그인 실패',
  // JWT 토큰 무효
  5102: 'JWT 무효',
  // 사용자 없음
  5103: '사용자가 존재하지 않습니다',
  // size 매개변수 오류
  5401: 'size 매개변수 오류',
  // page 매개변수 오류
  5402: 'page 매개변수 오류',
  // 검색 키워드 오류
  5403: '검색 키워드 오류'
}



// WEBPACK FOOTER //
// ./src/langs/ko/index.js